import templateUrl from "./session-expired.component.html";

/**
 * An error message component that, when rendered, redirects the user
 * to the signin page.
 */
export const SessionExpiredComponent = {
    templateUrl,
    bindings: {
        returnUrl: "<"
    },
    controller: class {
        constructor($state, $timeout, $window) {
            'ngInject';
            this.$state = $state;
            this.$timeout = $timeout;
            this.$window = $window;
        }
        $onInit() {
            // Delay the redirect. If the component is rendered before attaching the MVC route reload blocks,
            // the user will end up at an empty page, which is not ideal.
            this.$timeout(() => {
                return this.$state.go("account.login", { returnUrl: this.returnUrl });
            }, 3000)
        }
    }
}
